/**
 * An explicit logout from the access-code page means "wrong account".
 * Remember that intent in this tab across the Auth0 logout round trip. Keep it
 * through interrupted login attempts, then clear it on a successful callback.
 * No provider defaults or silent token requests are changed.
 */
import type { RedirectLoginOptions } from '@auth0/auth0-react';

const STORAGE_KEY = 'deepthink.auth.select-account-after-logout';

export function recordLogoutAccountSelection(pathname: string): void {
  try {
    if (pathname.replace(/\/+$/, '') === '/pending-approval') {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } else {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Unavailable storage must not prevent logout.
  }
}

export function clearLogoutAccountSelection(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Unavailable storage must not prevent completing login.
  }
}

export function withLogoutAccountSelection(
  options?: RedirectLoginOptions
): RedirectLoginOptions | undefined {
  try {
    if (window.sessionStorage.getItem(STORAGE_KEY) !== '1') return options;
  } catch {
    return options;
  }

  return {
    ...options,
    authorizationParams: {
      ...options?.authorizationParams,
      prompt: 'select_account',
      max_age: 0,
    },
  };
}
